import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface GlobalClassFilterState {
  selectedClassIds: string[];
  selectedSiteIds: string[];
  isHydrated: boolean;
  classesVersion: number;
}

const initialState: GlobalClassFilterState = {
  selectedClassIds: [],
  selectedSiteIds: [],
  isHydrated: false,
  classesVersion: 0,
};

const EMPTY_SELECTION: string[] = [];

export const globalClassFilterSlice = createSlice({
  name: 'globalClassFilter',
  initialState,
  reducers: {
    setSelectedClassIds: (state: GlobalClassFilterState, action: PayloadAction<string[]>) => {
      state.selectedClassIds = action.payload;
    },
    hydrateSelectedClassIds: (state: GlobalClassFilterState, action: PayloadAction<string[]>) => {
      state.selectedClassIds = action.payload;
      state.isHydrated = true;
    },
    setSelectedSiteIds: (state: GlobalClassFilterState, action: PayloadAction<string[]>) => {
      state.selectedSiteIds = action.payload;
    },
    noteClassesChanged: (state: GlobalClassFilterState) => {
      state.classesVersion += 1;
    },
  },
});

export const selectSelectedClassIds = (state: RootState) =>
  state.globalClassFilter?.selectedClassIds ?? EMPTY_SELECTION;

export const selectGlobalClassFilterHydrated = (state: RootState) => state.globalClassFilter?.isHydrated ?? false;

export const selectSelectedSiteIds = (state: RootState) => state.globalClassFilter?.selectedSiteIds ?? EMPTY_SELECTION;

export const selectClassesVersion = (state: RootState) => state.globalClassFilter?.classesVersion ?? 0;

export const { setSelectedClassIds, setSelectedSiteIds, hydrateSelectedClassIds, noteClassesChanged } =
  globalClassFilterSlice.actions;

export default globalClassFilterSlice.reducer;
